(function () {

  var linkFunction = function ($scope, element, attrs) {
    // console.log("SPC Footer Link Func: ", $scope, element, attrs);
  }

  var controllerFunction = function ($scope, $state, CAD) {
    // console.log("SPC Footer Controller Func: ", $scope);
    /** SP 01/17/2017 - Guest refill UAT comments
     * Identifying if the flow is in desktop to show status bar
     * @returns {boolean}
     */

    $scope.checkNative = cvsUtility.setNativeCheck();

    $scope.showDisclaimer = function () {
      if (cvsUtility.getPlatform() === 'dweb') {
        return true;
      } else if ($state.current.name === 'PZN') {
        return false;
      }
      return true;
    }

    $scope.isQuickReg = function () {
      return $state.is('quick-reg');
    }

    // $scope.faqRedirection=function(event){

    //   if(event && event.target && event.target.innerHTML && event.target.innerHTML=="read our frequently asked questions"){
    //     event.preventDefault();
    //     if ($scope.checkNative) { // to set the opeExtUrl native method
    //       var url = CVS.Config.parentHost.Web[cvsUtility.queryMap.env] + CVS.Config.redirectUrls.Web['faq'];
    //       // console.log("url",url)
    //       native.openExtUrl(url);
    //     } else {
    //       window.top.location = createChannelUrl('faq');
    //     }
    //   }else if(event && event.target && event.target.innerHTML && event.target.innerHTML.indexOf("800")>-1){

    //   }else{
    //     event.preventDefault();
    //   }

    // };

    // $scope.removeExtraCharacter=function(value){
    //   if(typeof value === "object"){
    //           console.log("spcFooter  ",value);
    //     var abc=value.__text;
    //     var abc=abc.replaceAll("\n-\n","-");
    //     return abc;
    //       }
    //   return value;
    // };

    var isFEPClient = false;
    var isFAQClient = false;

    $scope.fepContactUs = function () {
      var getBrandingInfoObj = CAD.getBrandingInfos();
      if (getBrandingInfoObj != "") {
        if (getBrandingInfoObj[0].clientInfo.clientName == 'FEP') {
          isFEPClient = true;
        }
      }
      cvsUtility.checkIfFepClient(isFEPClient);
    };


    $scope.fepFAQpage = function () {
      var getBrandingInfoObj = CAD.getBrandingInfos();
      if (getBrandingInfoObj != "") {
        if (getBrandingInfoObj[0].clientInfo.clientName == 'FEP') {
          isFAQClient = true;
        }
      }
      cvsUtility.checkIfFepClientFAQ(isFAQClient);
    };

    $scope.content = wcmContent;

  }

  var directiveFunction = function () {
    return {
      restrict: 'E',
      templateUrl: '../payments/app/components/spcFooter/spcFooter.template.html',
      controller: controllerFunction,
      link: linkFunction
    }
  }

  controllerFunction.$inject = ["$scope", "$state", "cvsAppData"];
  angular.module('cvsApp').directive('spcFooter', directiveFunction);


})();